<template>
  <div class="app-tips">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'app-tips'
}
</script>

<style lang="scss">
.app-tips {
  padding: 10px 20px;
  background-color: rgba($color: #2a85ff, $alpha: .2);
  color: #333;
}
</style>
